 $(document).ready(function(){
    const swiper = new Swiper('.swiper-journey-items', {
      slidesPerView: 2.3,
      spaceBetween: 24,
      pagination: {
        el: "#swiper-journey-items-swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: '#swiper-journey-items-button-next',
        prevEl: '#swiper-journey-items-button-prev',
      },
      // Your swiper config
      on: {
        resize: () => {
          // setMaxHeight();
        },
        slideChangeTransitionEnd: () => {
          // setMaxHeight();
        }
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      breakpoints: {
        992: {
          slidesPerView: 2.3,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 16,
        },
        576: {
          slidesPerView: 2.2,
        },
        0: {
          slidesPerView: 1.2,
        spaceBetween: 16,
        },
      },
    });
});
// $(document).ready(() => {
//   // Function to calculate and set the max height
//   const setMaxHeight = () => {
//     let maxHeight = 0;

//     // Iterate through each .multicolumn-list__item
//     $('.journey-section .swiper-initialized .multicolumn-list__item').each(function() {
//       const currentHeight = $(this).height();
//       if (currentHeight > maxHeight) {
//         maxHeight = currentHeight;
//       }
//     });

//     // Set the max height as a CSS variable on the .journey-section element
//     $('.journey-section').css('--max-height', `${maxHeight}px`);
//   };

//   // Call the function on document ready with a delay of 500ms
//   setTimeout(setMaxHeight, 1000);

//   // Debounce function to optimize resize event
//   const debounce = (func, wait) => {
//     let timeout;
//     return (...args) => {
//       clearTimeout(timeout);
//       timeout = setTimeout(() => func.apply(this, args), wait);
//     };
//   };

//   // Call the function on window resize with debounce
//   $(window).on('resize', debounce(setMaxHeight, 100));
// });

//  $(document).ready(function(){
//     const swiper = new Swiper('.swiper-multicolumn-items', {
//       slidesPerView: 1.6,
//       spaceBetween: 24,
//       pagination: {
//         el: "#swiper-multicolumn-items-swiper-pagination",
//         type: "progressbar",
//       },
//       navigation: {
//         nextEl: '#swiper-multicolumn-items-button-next',
//         prevEl: '#swiper-multicolumn-items-button-prev',
//       },
//       breakpoints: {
//         992: {
//           slidesPerView: 1.6,
//           spaceBetween: 24,
//         },
//         768: {
//           slidesPerView: 1.5,
//           spaceBetween: 16,
//         },
//         576: {
//           slidesPerView: 1.3,
//         },
//         0: {
//           slidesPerView: 1.2,
//         spaceBetween: 16,
//         },
//       },
//     });
// })